import React from "react";
import "./Profile.css";
import Header from "../Header";
import Navbar from "../Navbar";
import { Link, withRouter} from "react-router-dom";

let Profile = () => (
  <div>
    <Navbar/>
    <Header/>
    <div style={{backgroundColor: 'green', minHeight: '450px', marginBottom: '0px !important'}} className="mb-0">
      <div className="container">
    <h1 className="pt-5 pb-3 wzl">THE WORLD LARGEST BAMBOO ECO-CITY DEVELOPER</h1>
    <hr className="mb-3"/>
    <p  data-aos="fade-in"  data-aos-offset="200"
    data-aos-delay="50"
    data-aos-duration="1000"
     className="text-light text-justify wl2">BAMBOO ECOLOGICAL COMMERCIAL, INDUSTRIAL &amp; TOURISM CITIES (GOOD MORNING BAMBOO CITIES) is being developed to capture the full
environmental, economic and social value from the ever growing demand for agriculture, construction, water, waste and energy related goods
and innovative services in Ghana, Sub-Saharan Africa and the rest of the developing world.
We are developing Bamboo ecological cities with our high quality disruptive innovative Bamboo Composite Affordable Eco-Homes at 50% less
cost. These Eco-Homes will store CO2 like Forest, using Bamboo, Lime, Laterite, Biochar materials etc.; without using Cement, Timber, Sand,
Metallic Roofing Sheets and PVC Pipes in their construction.
The Bamboo ecological cities will operate on renewable energy, sustainable water and zero waste systems. The cities’ roads will be constructed
with Biochar modified Asphalt. The Biochar will be the by-product from renewable energy generation supply to the cities.
The General Layout of the Bamboo Ecological City will be based on Permaculture principle and natural food forest ecosystem and every Eco-
Home within the Eco-City with have an excellent Greenhouse or Vertical Urban Farming facility.
We are working on solving 25% of global housing deficit, unemployment, reducing and building resilience against Climate Change; by
constructing new Bamboo Composite Affordable Eco-Homes in new ecological cities. This disruptive innovation in construction will help us to
avoid most of the mistakes we did in building our existing cities that have brought us to where we are today – Climate Change. So, instead of the
existing cities improving the environment, social and economic lives of the people living in them, they are rather responsible for around 70% of
the total greenhouse gas emissions globally.
</p>
</div>
</div>
  <div  className="bgpic">
  <div style={{color: 'yellow', opacity: '0.5'}} className="row">
  <div data-aos="flip-left" style={{ marginTop: '15%'}}  className="col-12 col-lg-3 col-sm-12 col-md-6 text-center p-4 bg-dark">
    <span><i style={{fontSize: '50px'}} class="fas fa-map-marker-alt"></i></span>
  <p style={{fontWeight: 'bold'}}>Land Allocation</p>
  <p style={{fontWeight: 'bold'}}>Investors can apply for Land at Good Morning Bamboo City</p>
  <p className="lm" style={{fontWeight: 'bold'}}>Learn More</p>
  </div>
  <div data-aos="flip-down"  data-aos-offset="200"
    data-aos-delay="100"
    data-aos-duration="600"
    data-aos-easing="ease-in-out"
    data-aos-mirror="true"
    data-aos-once="false"
   style={{ marginTop: '15%'}} className="col-12 col-lg-3 col-sm-12 col-md-6 text-center p-4 bg-dark">
    <span><i style={{fontSize: '50px'}} class="fas fa-tasks"></i></span>
<p style={{fontWeight: 'bold'}}>Business Opportunities</p>
<p style={{fontWeight: 'bold'}}>Significant opportunity to diversify the economy and localize manufacturing</p>
<p className="lm" style={{fontWeight: 'bold'}}>Learn More</p>
  </div>
  <div data-aos="flip-left" data-aos-delay="100"
    data-aos-duration="600"
    data-aos-easing="ease-in-out"
    data-aos-mirror="true"
    data-aos-once="false" style={{ marginTop: '15%'}} className="col-12 col-lg-3 col-sm-12 col-md-6 text-center p-4 bg-dark">
    <span><i style={{fontSize: '50px'}} class="fas fa-sitemap"></i></span>
<p style={{fontWeight: 'bold'}}>Key Enablers</p>
<p style={{fontWeight: 'bold'}}>Enable tenant’s efficient and sustainable operations in an integrated world-class</p>
<p className="lm" style={{fontWeight: 'bold'}}>Learn more</p>
  </div>
  <div data-aos="flip-down"  data-aos-offset="200"
    data-aos-delay="100"
    data-aos-duration="600"
    data-aos-easing="ease-in-out"
    data-aos-mirror="true"
    data-aos-once="false" style={{ marginTop: '15%'}} className="col-12 col-lg-3 col-sm-12 col-md-6 text-center p-4 bg-dark">
    <span><i style={{fontSize: '50px'}} class="fab fa-accusoft"></i></span>
<p style={{fontWeight: 'bold'}}>Download Brochure and Others</p>
<p style={{fontWeight: 'bold'}}>Our plans & investment opportunities</p>
<p className="lm" style={{fontWeight: 'bold'}}>Learn more</p>
  </div>
  </div>
  </div>
  <div>
    <h1 className="mt-5 vpl" style={{color: 'green', fontSize: '50px'}}>Value Propositions</h1>
    <p className="text-center vph" style={{fontSize: '24px'}}>Get ready for unmatched innovative construction materials and technology efficiencies</p>
    <div className="container">
    <div className="row vp">
      <div data-aos="zoom-out" className="col-12 col-lg-3 col-sm-12 col-md-6">
        <p style={{fontWeight: 'bold'}}><span className="mr-2"><i style={{color: 'green'}} class="fas fa-globe"></i></span>World-Class Operations</p>
      </div>
      <div data-aos="zoom-out" className="col-12 col-lg-3 col-sm-12 col-md-6">
      <p style={{fontWeight: 'bold'}}><span className="mr-2"><i style={{color: 'green'}} class="fas fa-plug"></i></span>Plug and Play Utilities</p>
      </div>
      <div data-aos="zoom-out" className="col-12 col-lg-3 col-sm-12 col-md-6">
      <p style={{fontWeight: 'bold'}}><span className="mr-2"><i style={{color: 'green'}} class="fas fa-dolly"></i></span>Logistics Zone</p>
      </div>
      <div data-aos="zoom-out" className="col-12 col-lg-3 col-sm-12 col-md-6">
      <p style={{fontWeight: 'bold'}}><span className="mr-2"><i style={{color: 'green'}} class="fas fa-city"></i></span>Smart City</p>
      </div>
      </div>
    </div>
    
  <section id="eplore-section" class=" py-5">
    <div className="container">
      <div className="row">  
        <div className="col-12 col-lg-6 col-sm-12 col-md-5">
          <div className="d-flex flex-row">
            <div className="p-4 align-self-start">
              <i className="fa fa-check"></i>
            </div>
            <div data-aos="fade-up" className="p-4 align-self-end">
        <p style={{fontWeight: 'bold', fontSize: '24px'}}>World-class Operations</p>
        <p>World-class facility management and one-stop shop.</p>
            </div>
          </div>
          </div>
          <div className="col-12 col-lg-6 col-sm-12 col-md-5">
          <div className="d-flex flex-row">
            <div className="p-4 align-self-start">
              <i className="fa fa-check"></i>
            </div>
            <div data-aos="fade-up" className="p-4 align-self-end">
            <p style={{fontWeight: 'bold', fontSize: '24px'}}>Plug - and Play Utilities</p>
              <p>Utilities connectivity provided to the tenants’ plots.</p>
            </div>
            </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 col-sm-12 col-md-5">
            <div className="d-flex flex-row">
            <div className="p-4 align-self-start">
              <i className="fa fa-check"></i>
            </div>
            <div data-aos="fade-up" className="p-4 align-self-end">
              <p style={{fontWeight: 'bold', fontSize: '24px'}}>Friendly Community</p>
              <p>Non-industrial development offered to 3rd party investors to develop residential, commercial, and recreational facilities using our disruptive innovative materials</p>
            </div>
            </div>
            </div>
            <div className="col-12 col-lg-6 col-sm-12 col-md-5">
            <div className="d-flex flex-row">
            <div className="p-4 align-self-start">
              <i className="fa fa-check"></i>
            </div>
            <div data-aos="fade-up" className="p-4 align-self-end">
              <p style={{fontWeight: 'bold', fontSize: '24px'}}>Logistics Zone</p>
              <p>Logistics zone inclusive of a small dry ports connected to the current road network and future Ghana railway and a bonded area.</p>
            </div>
            </div>
            </div>
            </div>
            <div className="col-12 col-lg-6 col-sm-12 col-md-5">
            <div className="d-flex flex-row">
            <div className="p-4 align-self-start">
              <i className="fa fa-check"></i>
            </div>
            <div data-aos="fade-up" className="p-4 align-self-end">
              <p style={{fontWeight: 'bold', fontSize: '24px'}}>Smart City</p>
              <p>Reliable and world-class infrastructure designed to leverage new technologies for the benefit of GOOD MORNING BAMBOO and its tenants.</p>
            </div>
            </div>
        </div>
      </div>
     
      <div className="container jumbotron">
      <p style={{fontWeight: 'bold', fontSize: '30px', color: 'green'}}>News & Events</p>
      <hr style={{width: '100%'}}/>
    <div className="row">
<div className="col-12 col-lg-5 col-sm-12 col-md-6">
<div className="card cardxx">
  <img src="https://i.imgur.com/0JcJekN.png" class="card-img-top imgx" alt="..."/>
  <div className="card-body">
    <p style={{fontSize: '14px'}} class="card-text">Ghana National Competition - Organized by Ghana Climate Innovation Centre in Ghana 
2nd Position.<br/><span style={{marginLeft: '27%'}}><a style={{color: 'green'}} href="www.ghanacic.org/sabon-sake-wins-climate-launchpad-ghana-2019-competition">Click here</a></span>
</p>
</div>
  </div>
  <div className="card cardxx">
  <img src="https://i.imgur.com/Ms0VNEJ.png" class="card-img-top" alt="..."/>
  <div className="card-body">
    <p style={{fontSize: '14px'}} class="card-text">Africa Regional Competition - Organized by Kenya Climate Innovation Centre in Kenya 
Sustainable Production Systems Category 
1st Position.<br/><span style={{marginLeft: '27%'}}><a style={{color: 'green'}} href="https://twitter.com/hashtag/TeamBambooComposite?src=hash">Click here</a></span>
</p>
  </div>
  </div>

</div>
<div className="col-12 col-lg-4 col-sm-12 col-md-6">
<div className="card" style={{width: '18rem'}}>
  <img src="https://i.imgur.com/i2gLoAs.jpg" class="card-img-top" alt="..."/>
  <img src="https://i.imgur.com/cQ3r0pj.jpg" class="card-img-top" alt="..."/>
  <div className="card-body">
    <p style={{fontSize: '14px'}} class="card-text">Awards – Climate Launchpad Global Grand Final Competition in Amsterdam, The Netherlands.
We presented our innovation at the Semi-Finals and won two Judges who want to become Investors in our Business Model.
<br/><span style={{marginLeft: '27%'}}><a style={{color: 'green'}} href="twitter.com/hashtag/CLP19?src=hash">Click here</a></span>
</p>
  </div>
</div>
<div className="card" style={{width: '18rem'}}>
  <img src="https://i.imgur.com/HhT5lbE.jpg" class="card-img-top" alt="..."/>
  <img src="https://i.imgur.com/pAWuNcJ.jpg" class="card-img-top" alt="..."/>
  <div class="card-body">
    <p style={{fontSize: '14px'}} class="card-text">We participated in the Commissioning of Carmeuse Lime Products Gh. Ltd’s Lime Bricks Green Project on the 10th January 2020, at their Factory Sitein Takoradi, Ghana, West Africa.

Photo with Carmeuse Team – From left to right: Project Architect; Board Chairman for Carmeuse (Ghana); Technical Manage, Carmeuse; Rep from Carmeuse, Belguim; and Myself, Samuel Worwui, Founder & CEO Good Morning Bamboo.
</p>
  </div>
</div>
</div>
<div className="col-12 col-lg-3 col-sm-12 col-md-6">
<p style={{fontWeight: 'bold', fontSize: '24px', color: 'green'}}>Upcoming Events</p>
<div className="card" style={{width: '100%'}}>
  <img src="https://i.imgur.com/2CsH8Mm.png" class="card-img-top" alt="..."/>
  <div class="card-body">
    <p style={{fontSize: '14px'}} class="card-text">THE WORLD BUSINESS ANGELS INVESTMENT FORUM (WBAF) Investment Committee has selected GOOD MORNING BAMBOO Startup as one of the 100 Category ‘A’ startups, scale ups and high-growth businesses to participate in the Global Fundraising Stage of the World Congress of Angel Investors — WBAF 2020 which is scheduled for 17th and 18th February 2020 at Swissotel The Bosphorus, Istanbul, Turkey. The official website for this great event is:<a style={{color: 'green'}} href="https://www.wbaf2020.istanbul/"> https://www.wbaf2020.istanbul/</a>
</p>
  </div>
</div>
<div className="card" style={{width: '100%'}}>
  <img src="https://i.imgur.com/WogpkJe.png" class="card-img-top" alt="..."/>
  <div className="card-body">
    <p style={{fontSize: '14px'}} class="card-text">GOOD MORNING BAMBOO Startup has also been selected in the DISRUPTOR CATEGORY OF THE TONY ELUMELU FOUNDATION (TEF) 2020 PROGRAM. This very important program will also take off by March 2020.
</p>
  </div>
</div>
</div>
    </div>
      </div>
    </div>
  </section>
  </div>
  </div>
)

export default withRouter(Profile);
